import { render, staticRenderFns } from "./my-aleph-book.vue?vue&type=template&id=6f147296&scoped=true&"
import script from "./my-aleph-book.vue?vue&type=script&lang=js&"
export * from "./my-aleph-book.vue?vue&type=script&lang=js&"
import style0 from "./my-aleph-book.vue?vue&type=style&index=0&id=6f147296&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f147296",
  null
  
)

export default component.exports